import { useEffect, useState, useRef } from "react";
import { userData, focusElement, inputOnEnter } from "../js/utils";
import { post } from "../js/post";

export function CodeScanning({ opticalId, onRegister }) {
  const [stock, setStock] = useState(1);
  const scannedCodeRef = useRef("");
  const queueRef = useRef([]);
  const processingRef = useRef(false);

  // console.log("stock: ", stock);

  function handleInputChange(e) {
    scannedCodeRef.current = e.target.value;
  }

  function handleStock(e) {
    setStock(Math.max(1, parseInt(e.target.value) || 1));
  }

  async function processQueue() {
    if (processingRef.current) return;
    processingRef.current = true;
    while (queueRef.current.length > 0) {
      const { code, stockValue } = queueRef.current.shift();
      const response = await post(
        "support-extra/traspasosMultiples/ObtenerProductoTraspasoMultiple.php",
        {
          token: userData.token,
          opticaOrigen: opticalId,
          codigo: code,
        },
      );
      // console.log(
        // ">> OBTENIENDO PROD. TRASPASO MÚLTIPLE: ",
        // { token: userData.token, opticaOrigen: opticalId, codigo: code },
        // response,
      // );
      onRegister({ ...response, stockTraspaso: parseInt(stockValue) });
    }
    processingRef.current = false;
  }

  function insertScannedCode() {
    const scannedCode = scannedCodeRef.current.trim();
    if (!scannedCode) return;

    const stockValue = stock;
    scannedCodeRef.current = "";
    document.getElementById("scannedCodeInput").value = "";
    setStock(1);

    queueRef.current.push({ code: scannedCode, stockValue });
    processQueue();
  }

  useEffect(() => {
    focusElement(51);
  }, []);

  return (
    <div className="thin-rounded-border">
      <div className="opt-table-title opt-table-title-button">
        Lectura de códigos
      </div>
      <div className="code-reading-container-input">
        <div className="cell cell-label cell-extra">Stock</div>
        <div className="input-data input-small">
          <input
            type="number"
            value={stock}
            onChange={handleStock}
            tabIndex={50}
            onKeyUp={(e) => inputOnEnter(e)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                insertScannedCode();
              }
            }}
          ></input>
        </div>
        <div className="cell cell-label cell-extra">Código</div>
        <div className="input-data input-medium">
          <input
            id="scannedCodeInput"
            tabIndex={51}
            type="type-alphanum-ext"
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === "Enter" && scannedCodeRef.current !== "") {
                insertScannedCode();
              }
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
          <img
            src="/images/search-blue.svg"
            loading="lazy"
            alt="Panel icon"
            className="vectors-wrapper-11"
          ></img>
        </div>
      </div>
    </div>
  );
}
